const _import = require('../import-' + process.env.NODE_ENV)

const opinionRouter = [
  {
    path: '/Opinion/Create',
    // name: 'OpinionCreate',
    component: _import('Opinion/tishi'),
    meta: {
      title: '盗版提示'
    }},
  {
    path: '/Opinion/CreateOpin',
    name: 'OpinionCreate',
    component: _import('Opinion/Create'),
    meta: {
      auth: true,
      title: '发表投诉',
      keepAlive: true
    }},
  {
    path: '/Opinion/List',
    name: 'OpinionList',
    component: _import('Opinion/List'),
    meta: {
      title: '曝光列表',
      keepAlive: true
    }},
  {
    path: '/Opinion/MyList',
    name: 'MyOpinionList',
    component: _import('Opinion/MyList'),
    meta: {
      auth: true,
      title: '我的投诉',
      keepAlive: true
    }
  }
]
export default opinionRouter



// WEBPACK FOOTER //
// ./src/router/home/opinion.js